import React from 'react';
import ZoneMemberCard from '../../../components/Zones/ZoneMemberCard/ZoneMemberCard';
import style from "./ZoneMembers.module.css";
const ZoneMembers = ({ members,report,expel }) => {
    return (
        <div className=''>
            <div className={style.zone_members_container}>
                {
                    members.map(member => (
                        <ZoneMemberCard key={member._id} member={member} report={report} expel ={expel} />
                    ))
                }
            </div>
        </div>
    )
};

export default ZoneMembers;
